import api from '@http/api';

export interface IApproveSolicitacao {
  id_solicitacao: number[];
}

class ComponentModalRecusaServices {
  public async RecusarLote(loteId: number,  observacao: string) {
    return await api
      .post( `/api/Doacao/RecusarLote?loteId=${loteId}`, {observacao}, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }
}

export default ComponentModalRecusaServices;
